/* istanbul ignore file */
import { Show } from 'framework/show';
import { useServiceCatalogService } from 'domain/shared/serviceCatalog';
import { useServiceCatalogId } from 'domain/organization/serviceCatalog/useServiceCatalogId';
import ViewServiceCatalogPageContent from 'domain/organization/serviceCatalog/Show/ViewServiceCatalogPageContent';

const ServiceCatalogViewPage = () => {
  const { getById } = useServiceCatalogService();
  const id = useServiceCatalogId();

  return (
    <Show getDataMethod={() => getById(id)}>
      <ViewServiceCatalogPageContent />
    </Show>
  );
};

export default ServiceCatalogViewPage;
